<template>
  <div :class="{'question': true, 'active': active == index}">
    <div class="title-row" @click="switchContent">
      <div class="title-box">{{ title }}</div>
      <div class="icon-box">
        <font-awesome-icon :icon="['fas', 'angle-double-down']" class="icon"/>
      </div>
    </div>
    <div class="content-row" v-if="active == index">
      <div class="work-in-progress" v-if="!videoId">
        Content will be available soon
      </div>
      <div class="video" v-if="videoId">
        <div class="loading-box" v-if="loading">
          <Loader color="rgb(199, 190, 190)"/>
        </div>
        <youtube width="100%" height="100%" :video-id="videoId" ref="youtube" @ready="onReady"/>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  name: 'Question',
  props: {
    title: String,
    index: String,
    active: String,
    videoId: String
  },
  data() {
    return {
      loading: true,
    }
  },
  components: {
    Loader,
  },
  methods: {
    switchContent() {
      if(this.active == this.index) {
        this.closeContent();
      } else {
        this.openContent();
      }
    },
    openContent() {
      this.$emit('open', this.index);
      this.loading = true;
    },
    closeContent() {
      this.$emit('close');
    },
    onReady() {
      this.loading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.question {
  width: 98%;
  min-height: 4rem;
  display: flex;
  flex-direction: column;
  padding-left: 2rem;
  padding-right: 2rem;

  @media (max-width: 1000px) {
    width: 95%;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  @media (max-width: 500px) {
    width: 100%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .title-row {
    width: 100%;
    height: 4rem;
    display: flex;
    border-bottom: 1px solid rgb(199, 190, 190);
    transition: 0.2s;
    
    &:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.062);
    }
  }

  .title-box {
    display: flex;
    align-items: center;
    font-size: 1rem;
    margin-left: 1rem;
  }

  .icon-box {
    width: 4rem;
    height: 4rem;
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      color: rgb(199, 190, 190);
      font-size: 1.5rem;
    }
  }

  .content-row {
    background-color: rgba(0, 0, 0, 0.062);
    border-bottom: 1px solid rgb(199, 190, 190);
    width: 100%;
    height: 20rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .work-in-progress {
      color: rgb(199, 190, 190);
      font-weight: bold;
      font-size: 1.5rem;
      padding-left: 1rem;
      padding-right: 1rem;
      text-align: center;
      line-height: 2rem;
    }

    .video {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .loading-box {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.active {
  .title-row {
    background-color: rgba(0, 0, 0, 0.062);
    &:hover {
      background-color: rgba(0, 0, 0, 0.096);
    }
  }
  .icon-box {
    .icon {
      transform: rotate(180deg);
    }
  }
}
</style>